/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';

import { ICittaNewsletterSubscribePopUpViewProps } from './citta-newsletter-subscribe-pop-up';

export default (props: ICittaNewsletterSubscribePopUpViewProps) => {
    const { 
        newsletterSubscribe,
        message,
        header,
        closeButton,
        MessageTextProps,
        HeaderTextProps,
        cookieValue
    } = props;

    if(!newsletterSubscribe || !newsletterSubscribe.length) {
        props.context.telemetry.error('newsletter content is empty, module wont render');
        return null;
    }
    return (
        <div className={`citta-newsletter-subscribe-pop-up ${cookieValue}`}>
            <div className="close-pop-up">
                {closeButton}
            </div>
            {header && <Node {...HeaderTextProps}><h6>{header}</h6></Node>}
            {message && <Node {...MessageTextProps}><p>{message}</p></Node>}

            {newsletterSubscribe}
        </div>
    );
};
